import { apiClient } from "../plugins/api"

export class GuardianshipService {
  static getLoggedInGuardian() {
    let guardian = {}
    return apiClient.oauth.get(`/oauth/userinfo`).then((response) => {
      guardian.given_name = response?.data?.given_name
      guardian.family_name = response?.data?.family_name

      if (response?.data?.email) {
        guardian.email = response.data.email
        guardian.login = response.data.email
        guardian.login_type = 'email'
      } else if (response?.data?.phone_number) {
        guardian.phone_number = response.data.phone_number
        guardian.login = response.data.phone_number
        guardian.login_type = 'phone'
      }
      return guardian
    })
  }

  static getWard(magicCode = null) {
    if (!magicCode) {
      return
    }

    return apiClient.auth.get(`/wards?ward[magic_code]=${magicCode}`).then((response) => {
      // We dont have magic_code in the backend response, so we add it here.
      return {...response.data, magic_code: magicCode}
    }, (err) => {
      const status = err.toJSON().status
      const backendMessage = err.response?.data?.error
      let message
      if (status === 404) {
        message = `Magic code ${magicCode} not found`
      } else if (backendMessage) {
        message = backendMessage
      } else {
        message = `Something went wrong looking up magic code "${magicCode}". Please try re-adding that code again.`
      }
      return Promise.reject({ error: message })
    })
  }

  static reSendCode(key = "#", magicCodes) {
    apiClient.auth.post(`/guardianships/${key}/send_code/`, { magic_codes: magicCodes }).then((response) => {
      window.location = response.data.redirect_url;
    });
  }

  static getWards(magicCodes = []) {
    return Promise.allSettled(magicCodes.map(async (code) => {
      return this.getWard(code)
    }))
  }

  static update(wards) {
    return this.save(null, wards)
  }

  static save(guardian, wards) {
    const options = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }
    let payload = {
      wards: wards.map(w => { return { magic_code: w.magic_code, name: w.name } }),
      skip_invite: true
    }
    if (guardian) {
      payload = {
        ...guardian,
        ...payload
      }
    }
    return apiClient.auth.post("/guardianships", payload, options)
  }
}